import { connect } from 'react-redux'
import UI from './UI'
import { addCardAction, addPaypalAction, ChangeDefaultPaymentMethodAction, deleteCardAction, deletePaypalAction, fetchCardsAction } from 'store/payment'

const mapStateToProps = ({ payment, currency, support, cart }) => ({
  cards: payment.creditCards,
  loadingCreditCards: payment.loadingCreditCards,
  addingCreditCard: payment.addingCreditCard,
  currency: currency.initialCurrency,
  email: support.Email,
  shopId: support.Id,
  price: cart.Total
})

const mapDispatchToProps = (dispatch) => ({
  addCreditCard: (data, additionalFunction) => dispatch(addCardAction(data, additionalFunction)),
  addPaypalAccount: (pathname) => dispatch(addPaypalAction(pathname)),
  fetchCards: () => dispatch(fetchCardsAction()),
  changeDefaultPaymentMethodAction: cardId => dispatch(ChangeDefaultPaymentMethodAction(cardId)),
  deleteCard: data => dispatch(deleteCardAction(data)),
  deletePaypal: data => dispatch(deletePaypalAction(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
